/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDropdownMenu]',
    exportAs: 'appDropDown'
})

export class DropdownMenuDirective {

    /**
     * dropdown state
     */
    public manageDropdown: boolean = false;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2) {
    }

    @HostListener('click')
    public openDropdown() {
        if (!this.manageDropdown) {
            this.renderer.addClass(this.elementRef.nativeElement, 'open');
            this.manageDropdown = !this.manageDropdown;
        } else {
            this.renderer.removeClass(this.elementRef.nativeElement, 'open');
            this.manageDropdown = !this.manageDropdown;
        }
    }

    /**
     *
     * @param event
     * @param targetElement
     */
    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(targetElement: HTMLElement): void {
        if (!targetElement) {
            return;
        }

        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.renderer.removeClass(this.elementRef.nativeElement, 'open');
            this.manageDropdown = false;
        }
    }
}
